export class Reports {
	constructor() {
		document.querySelectorAll('.reports[data-ajax="1"]').forEach((root) => {
			this.bind(root);
		});
	}

	bind(root) {
		const config = window.icarReports;

		if (!config?.ajaxUrl) {
			return;
		}

		const results = root.querySelector('.reports__results');

		if (!results) {
			return;
		}

		const fetchResults = async (params, { updateUrl = true, scroll = false } = {}) => {
			root.classList.add('is-loading');

			const body = new FormData();
			body.append('action', config.action);
			body.append('nonce', config.nonce);

			Object.entries(params).forEach(([key, value]) => {
				if (value !== undefined && value !== null && value !== '') {
					body.append(key, String(value));
				}
			});

			try {
				const response = await fetch(config.ajaxUrl, {
					method: 'POST',
					body,
					credentials: 'same-origin',
				});

				const payload = await response.json();

				if (!payload?.success) {
					return;
				}

				results.innerHTML = payload.data.html;

				if (payload.data.category !== undefined) {
					this.setActiveFilter(root, payload.data.category);
				}

				if (updateUrl) {
					this.updateUrl(params);
				}

				if (scroll) {
					root.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			} finally {
				root.classList.remove('is-loading');
			}
		};

		const getCurrentState = () => {
			const searchInput = root.querySelector('.reports__search-input');
			const perPageSelect = root.querySelector('.reports__per-page-select');
			const activeFilter = root.querySelector('.reports__filter.is-active');

			return {
				'report-categories': activeFilter?.dataset.reportCategory || 'all',
				search: searchInput?.value?.trim() || '',
				posts_per_page: perPageSelect?.value || '12',
				paged: '1',
			};
		};

		root.addEventListener('click', (event) => {
			const filter = event.target.closest('.reports__filter');

			if (filter && root.contains(filter)) {
				event.preventDefault();

				const state = getCurrentState();
				state['report-categories'] = filter.dataset.reportCategory || 'all';
				state.paged = '1';

				fetchResults(state, { scroll: true });
				return;
			}

			const copyButton = event.target.closest('.share-social__copy');

			if (copyButton && root.contains(copyButton)) {
				event.preventDefault();
				const link = copyButton.dataset.link;
				if (!link) {
					return;
				}
				navigator.clipboard.writeText(link);
				return;
			}

			const pageLink = event.target.closest('.reports__pagination a');

			if (pageLink && root.contains(pageLink)) {
				event.preventDefault();

				const state = getCurrentState();
				state.paged = String(this.getPageFromLink(pageLink));

				fetchResults(state, { scroll: true });
			}
		});

		const searchForm = root.querySelector('.reports__search');
		const searchInput = root.querySelector('.reports__search-input');

		if (searchForm) {
			searchForm.addEventListener('submit', (event) => {
				event.preventDefault();

				const state = getCurrentState();
				state.paged = '1';

				fetchResults(state, { scroll: true });
			});
		}

		if (searchInput) {
			let lastSearch = searchInput.value.trim();

			searchInput.addEventListener('input', () => {
				const value = searchInput.value.trim();

				if (value === '' && lastSearch !== '') {
					const state = getCurrentState();
					state.search = '';
					state.paged = '1';

					fetchResults(state);
				}

				lastSearch = value;
			});
		}

		root.addEventListener('change', (event) => {
			const select = event.target.closest('.reports__per-page-select');

			if (!select || !root.contains(select)) {
				return;
			}

			const state = getCurrentState();
			state.posts_per_page = select.value;
			state.paged = '1';

			fetchResults(state, { scroll: true });
		});
	}

	setActiveFilter(root, category) {
		root.querySelectorAll('.reports__filter').forEach((link) => {
			link.classList.toggle('is-active', link.dataset.reportCategory === category);
		});
	}

	getPageFromLink(anchor) {
		const url = new URL(anchor.href, window.location.origin);
		const queryPage = url.searchParams.get('paged');

		if (queryPage) {
			return Math.max(1, parseInt(queryPage, 10));
		}

		const pathMatch = url.pathname.match(/\/page\/(\d+)\/?$/);

		if (pathMatch) {
			return Math.max(1, parseInt(pathMatch[1], 10));
		}

		return 1;
	}

	updateUrl(params) {
		const url = new URL(window.location.href);

		url.searchParams.delete('report-categories');
		url.searchParams.delete('search');
		url.searchParams.delete('posts_per_page');
		url.searchParams.delete('paged');

		if (params['report-categories'] && params['report-categories'] !== 'all') {
			url.searchParams.set('report-categories', params['report-categories']);
		}

		if (params.search) {
			url.searchParams.set('search', params.search);
		}

		if (params.posts_per_page && params.posts_per_page !== '12') {
			url.searchParams.set('posts_per_page', params.posts_per_page);
		}

		if (params.paged && params.paged !== '1') {
			url.searchParams.set('paged', params.paged);
		}

		window.history.pushState({}, '', url);
	}
}
